import { render, staticRenderFns } from "./broker_job.vue?vue&type=template&id=24e69686&scoped=true"
import script from "./broker_job.vue?vue&type=script&lang=js"
export * from "./broker_job.vue?vue&type=script&lang=js"
import style0 from "./broker_job.vue?vue&type=style&index=0&id=24e69686&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e69686",
  null
  
)

export default component.exports